export const widgets = {
  zohoCrm: {
    settings: {
      welcomeToBotPenguin: 'Välkommen till BotPenguin!',
      login: 'Logga in',
      youAreAllSet: 'Du är redo! Du kan använda WhatsApp-inboxen från lead-detaljsidan.',
      placeholders: {
        enterEmail: 'Ange e-post',
        enterPassword: 'Ange lösenord'
      }
    }
  }
};
